import { Component } from "react"

/* Components */
import { Input, Icon } from "../../components"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* REST API */
import { edit, removeImage, uploadImage } from "../../api/Organization"

/* Constants */
import { env } from "../../constants"

/* Helpers */
import { utils } from "../../helpers"

/* Shared */
import { SOCIALS } from "./shared"

/* Widgets */
import { toast, confirm } from "../common"


/* Widget Settings Tab — the whole card of the point in one form. The page of the editing is gone,
   so everything the base keeps about a point is settled here: the contacts, the address, the
   categories, the networks, the ways it takes money, the amenities and the flags */
class SettingsTab extends Component {

    constructor(props) {
        super(props)

        const { organization, categories, images, paymentIDs, amenities } = props.data

        /* The networks of the point, every one of them as it stands in the base */
        let socials = {}

        for (const social of SOCIALS) {
            socials[social.key] = utils.check(organization[social.key], "")
        }

        this.state = {

            name: utils.check(organization.name, ""),
            phone: utils.check(organization.phone, ""),
            iin: utils.check(organization.iin, ""),
            url: utils.check(organization.url, ""),
            description: utils.check(organization.description, ""),

            address: utils.check(organization.address, ""),
            lat: utils.check(organization.lat, ""),
            lng: utils.check(organization.lng, ""),
            cityID: utils.check(organization.cityID, 0),

            serviceMode: utils.check(organization.serviceMode, "TIME_BASED"),
            gift: parseInt(organization.gift) ? 1 : 0,
            whatsappLanguage: organization.whatsappLanguage === "ru" || organization.whatsappLanguage === "kk" ? organization.whatsappLanguage : "",

            selected: categories.map(category => parseInt(category.id)),
            payments: utils.check(paymentIDs, []).map(payment => parseInt(payment)),
            amenities: utils.check(amenities, []),
            amenity: "",

            socials,
            images,

            waiting: false
        }
    }

    /* Change one network of the point */
    setSocial = (key, value) => {
        this.setState(previous => ({ socials: { ...previous.socials, [key]: value } }))
    }

    /* Add the category to the point or take it away */
    category = categoryID => {

        const { selected } = this.state
        const index = selected.findIndex(item => item === categoryID)

        if (index > -1) {
            selected.splice(index, 1)
        }
        else {
            selected.push(categoryID)
        }

        this.setState({ selected })
    }

    /* Add the way of paying or take it away */
    payment = paymentID => {

        const { payments } = this.state
        const index = payments.findIndex(item => item === paymentID)

        if (index > -1) {
            payments.splice(index, 1)
        }
        else {
            payments.push(paymentID)
        }

        this.setState({ payments })
    }

    /* Add what the client finds at the point or take it away */
    amenity = text => {

        const { amenities } = this.state
        const index = amenities.findIndex(item => item === text)

        if (index > -1) {
            amenities.splice(index, 1)
        }
        else {
            amenities.push(text)
        }

        this.setState({ amenities })
    }

    /* Write an amenity the catalogue does not know */
    addAmenity = event => {

        event.preventDefault()

        const { amenity, amenities } = this.state
        const text = amenity.trim().slice(0, 40)

        /* An empty one and a double of the one already written are dropped */
        if (text.length === 0 || amenities.indexOf(text) > -1) {
            this.setState({ amenity: "" })
            return
        }

        amenities.push(text)
        this.setState({ amenities, amenity: "" })
    }

    /* Save the card of the point */
    save = () => {

        /* Fields */
        const { name, phone, iin, url, description, address, lat, lng, cityID, serviceMode, gift, whatsappLanguage, selected, payments, amenities, socials, waiting } = this.state
        const { data, reload } = this.props

        /* The request is already on its way */
        if (waiting) {
            return
        }

        if (name.length === 0) {
            this._name.error("Введите название организации")
            return
        }

        if (phone.length !== 18) {
            this._phone.error("Введите телефон организации")
            return
        }

        if (address.length === 0) {
            this._address.error("Введите адрес организации")
            return
        }

        if (lat.length === 0) {
            this._lat.error("Введите широту")
            return
        }

        if (lng.length === 0) {
            this._lng.error("Введите долготу")
            return
        }

        if (!cityID) {
            toast.error("Выберите город")
            return
        }

        if (selected.length === 0) {
            toast.error("Выберите хотя бы одну категорию")
            return
        }

        this.setState({ waiting: true })

        edit({
            id: data.organization.id,
            name, phone, address, lat, lng, description,
            iin, url, cityID, serviceMode, gift, whatsappLanguage,
            amenities,
            categories: selected,
            payments,
            ...socials
        }).then(response => {

            if (response.status === 200) {
                toast.success("Данные успешно сохранены")
                reload()
                return
            }

            /* The address on the site is taken by another point */
            if (response.status === 409) {
                this._url.error("Такая ссылка уже занята")
                return
            }

            toast.error("Что-то пошло не так! Попробуйте позднее.")
        }).catch(() => {
            toast.error("Что-то пошло не так! Попробуйте позднее.")
        }).finally(() => {
            this.setState({ waiting: false })
        })
    }

    /* Upload the photos of the point */
    upload = event => {

        const { data, reload } = this.props

        const body = new FormData()
        body.append("id", data.organization.id)

        for (const file of event.target.files) {
            body.append("image", file)
        }

        uploadImage(body).then(response => {
            if (response.status === 200) {
                this.setState({ images: response.data.images })
                reload()
                toast.success("Картинки успешно загружены")
            }
            else {
                toast.error("Что-то пошло не так! Попробуйте позднее.")
            }
        }).catch(() => {
            toast.error("Что-то пошло не так! Попробуйте позднее.")
        })
    }

    /* Remove one photo */
    removeImage = image => {

        const { data, reload } = this.props

        confirm({
            title: "Удалить фотографию?",
            confirmText: "Да, удалить",
            cancelText: "Отмена",
            danger: true
        }).then(confirmed => {

            if (!confirmed) {
                return
            }

            removeImage({ id: data.organization.id, image }).then(response => {
                if (response.status === 200) {
                    this.setState({ images: response.data.images })
                    reload()
                    toast.success("Картинка успешно удалена")
                }
                else {
                    toast.error("Что-то пошло не так! Попробуйте позднее.")
                }
            }).catch(() => {
                toast.error("Что-то пошло не так! Попробуйте позднее.")
            })
        })
    }

    /* The left column — who the point is and where it stands */
    _main = () => {

        /* Fields */
        const { name, phone, iin, url, description, address, lat, lng, cityID, selected, serviceMode, gift, whatsappLanguage } = this.state
        const { data } = this.props

        /* An older backend does not send the whole lists yet — the tab must not fall apart on it */
        const cities = utils.check(data.cities, [])
        const allCategories = utils.check(data.allCategories, [])

        return (
            <div className="organization-details-column">

                <div className="organization-details-section">

                    <div className="organization-details-section-text">Об организации</div>

                    <div className="organization-details-inputs">
                        <Input ref={ref => this._name = ref} label="Название организации" value={name} onChange={event => this.setState({ name: event.target.value })} />
                        <Input mask="+7 (999) 999-99-99" ref={ref => this._phone = ref} label="Телефон организации" value={phone} onChange={event => this.setState({ phone: event.target.value })} />
                    </div>

                    <div className="organization-details-inputs">
                        <Input ref={ref => this._iin = ref} label="ИИН / БИН" value={iin} onChange={event => this.setState({ iin: event.target.value })} />
                        <Input ref={ref => this._url = ref} label="Ссылка на сайте" value={url} onChange={event => this.setState({ url: event.target.value })} />
                    </div>

                    <Input textarea maxLength={600} hint="Клиент видит его в карточке заведения" ref={ref => this._description = ref} label="Описание" value={description} onChange={event => this.setState({ description: event.target.value })} />

                </div>

                <div className="organization-details-section">

                    <div className="organization-details-section-text">Адрес</div>

                    <Input ref={ref => this._address = ref} label="Адрес" value={address} onChange={event => this.setState({ address: event.target.value })} />

                    <div className="organization-details-inputs">
                        <Input ref={ref => this._lat = ref} label="Широта (lat)" value={lat} onChange={event => this.setState({ lat: event.target.value })} />
                        <Input ref={ref => this._lng = ref} label="Долгота (lng)" value={lng} onChange={event => this.setState({ lng: event.target.value })} />
                    </div>

                    <div className="wide-modal-label">Город</div>
                    <div className="organization-details-chips">
                        {cities.map(city =>
                            <div
                                key={`${city.id}`}
                                onClick={() => this.setState({ cityID: parseInt(city.id) })}
                                className={`organization-details-chip select ${parseInt(cityID) === parseInt(city.id) ? "active" : ""}`}
                            >
                                {city.name}
                            </div>
                        )}
                    </div>

                </div>

                <div className="organization-details-section">

                    <div className="organization-details-section-text">Категории</div>
                    <div className="organization-details-hint">Без категории точка выпадает из каталога приложения.</div>

                    <div className="organization-details-chips">
                        {allCategories.map(category =>
                            <div
                                key={`${category.id}`}
                                onClick={() => this.category(parseInt(category.id))}
                                className={`organization-details-chip select ${selected.indexOf(parseInt(category.id)) > -1 ? "active" : ""}`}
                            >
                                {category.name}
                            </div>
                        )}
                    </div>

                </div>

                <div className="organization-details-section">

                    <div className="organization-details-section-text">Режим работы</div>
                    <div className="organization-details-hint">Очередь — для автомоек и шиномонтажей: клиент берёт талон, а не время.</div>

                    <div className="organization-details-chips">
                        <div onClick={() => this.setState({ serviceMode: "TIME_BASED" })} className={`organization-details-chip select ${serviceMode === "TIME_BASED" ? "active" : ""}`}>Запись по времени</div>
                        <div onClick={() => this.setState({ serviceMode: "QUEUE_BASED" })} className={`organization-details-chip select ${serviceMode === "QUEUE_BASED" ? "active" : ""}`}>Электронная очередь</div>
                    </div>

                    <div className="wide-modal-label">Подарочные сертификаты</div>
                    <div className="organization-details-chips">
                        <div onClick={() => this.setState({ gift: 1 })} className={`organization-details-chip select ${gift ? "active" : ""}`}>Подключены</div>
                        <div onClick={() => this.setState({ gift: 0 })} className={`organization-details-chip select ${gift ? "" : "active"}`}>Отключены</div>
                    </div>

                    <div className="wide-modal-label">Язык WhatsApp-сообщений</div>
                    <div className="organization-details-hint">Клиентам и команде точки. «Как на платформе» — следует общему переключателю в Настройках.</div>
                    <div className="organization-details-chips">
                        <div onClick={() => this.setState({ whatsappLanguage: "" })} className={`organization-details-chip select ${whatsappLanguage === "" ? "active" : ""}`}>Как на платформе</div>
                        <div onClick={() => this.setState({ whatsappLanguage: "ru" })} className={`organization-details-chip select ${whatsappLanguage === "ru" ? "active" : ""}`}>Русский</div>
                        <div onClick={() => this.setState({ whatsappLanguage: "kk" })} className={`organization-details-chip select ${whatsappLanguage === "kk" ? "active" : ""}`}>Қазақша</div>
                    </div>

                </div>

            </div>
        )
    }

    /* The right column — the networks, the money, the amenities and the photos */
    _extra = () => {

        /* Fields */
        const { socials, payments, amenities, amenity, images } = this.state
        const { data, onRemove } = this.props

        const allPayments = utils.check(data.allPayments, [])
        const catalogue = utils.check(data.amenitiesCatalogue, [])

        /* The amenities the point wrote itself, outside of the catalogue */
        const own = amenities.filter(item => catalogue.indexOf(item) === -1)

        return (
            <div className="organization-details-column">

                <div className="organization-details-section">

                    <div className="organization-details-section-text">Социальные сети и карты</div>
                    <div className="organization-details-hint">Пустое поле убирает иконку из карточки заведения. В 2ГИС — ссылка на страницу компании.</div>

                    <div className="organization-details-inputs">
                        {SOCIALS.map(social =>
                            <Input
                                key={social.key}
                                label={social.text}
                                value={socials[social.key]}
                                onChange={event => this.setSocial(social.key, event.target.value)}
                            />
                        )}
                    </div>

                </div>

                <div className="organization-details-section">

                    <div className="organization-details-section-text">Способы оплаты</div>
                    <div className="organization-details-hint">Их видит клиент в карточке и мастер при закрытии записи.</div>

                    <div className="organization-details-chips">
                        {allPayments.length === 0 && <div className="organization-details-empty">Справочник пуст</div>}
                        {allPayments.map(payment =>
                            <div
                                key={`${payment.id}`}
                                onClick={() => this.payment(parseInt(payment.id))}
                                className={`organization-details-chip select ${payments.indexOf(parseInt(payment.id)) > -1 ? "active" : ""}`}
                            >
                                {payment.name}
                            </div>
                        )}
                    </div>

                </div>

                <div className="organization-details-section">

                    <div className="organization-details-section-text">Удобства</div>
                    <div className="organization-details-hint">Что клиент найдёт на точке. Максимум 20 пунктов, можно добавить свои.</div>

                    <div className="organization-details-chips">
                        {catalogue.map(item =>
                            <div
                                key={item}
                                onClick={() => this.amenity(item)}
                                className={`organization-details-chip select ${amenities.indexOf(item) > -1 ? "active" : ""}`}
                            >
                                {item}
                            </div>
                        )}

                        {own.map(item =>
                            <div key={item} onClick={() => this.amenity(item)} className="organization-details-chip select active">
                                {item} ✕
                            </div>
                        )}
                    </div>

                    <form onSubmit={this.addAmenity} className="organization-details-append">
                        <input placeholder="Своё удобство" value={amenity} maxLength={40} onChange={event => this.setState({ amenity: event.target.value })} />
                        <button type="submit">Добавить</button>
                    </form>

                </div>

                <div className="organization-details-section">

                    <div className="organization-details-section-text">Фотографии</div>
                    <div className="organization-details-hint">Первая фотография становится главной — её видит клиент в каталоге. Максимум 10 МБ на файл.</div>

                    <div className="organization-details-images">

                        {images.map((image, index) =>
                            <div className="organization-details-image editable" key={`${index}`}>
                                <img src={`${env.mediapoint}organizations/${image.image}`} alt="Organization" />
                                {image.main && <div className="organization-details-image-main">Главная</div>}
                                <div onClick={() => this.removeImage(image)} className="organization-details-image-remove">
                                    <Icon name="close" size={11} width={2.4} />
                                </div>
                            </div>
                        )}

                        <label className="organization-details-image upload">
                            <input onChange={event => this.upload(event)} multiple={true} type="file" name="file" accept="image/png, image/jpeg" />
                            <Icon name="image" size={20} />
                            <span>Добавить</span>
                        </label>

                    </div>

                </div>

                <div className="organization-details-section danger">

                    <div className="organization-details-section-text">Опасная зона</div>
                    <div className="organization-details-hint">Удаление точки отменить нельзя. Чтобы просто убрать её из приложения, отключите точку во вкладке «Информация».</div>

                    <div onClick={() => onRemove(data.organization)} className="organization-details-danger">
                        <Icon name="trash" size={17} />
                        <span>Удалить организацию</span>
                    </div>

                </div>

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { waiting } = this.state

        return (
            <div className="organization-details-body">

                <div className="organization-details-columns">
                    {this._main()}
                    {this._extra()}
                </div>

                <div onClick={() => this.save()} className={`organization-details-button sticky ${waiting ? "disabled" : ""}`}>
                    {waiting ? <LoadingOutlined /> : "Сохранить карточку"}
                </div>

            </div>
        )
    }
}

export default SettingsTab
